import AppNetwork from './AppNetwork';

export default AppNetwork;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetwork/index.ts